/**
 * Utility function to get the image path based on quality setting
 * 
 * @param {string} imageName - Base image name (e.g., 'newspaper.jpg' or 'newspaper.png')
 * @param {string} quality - Quality level: 'low_quality', 'medium_quality', or 'original'
 * @returns {string} Full path to the image file
 */
export const getImagePath = (imageName, quality = 'medium_quality') => {
  // Ensure imageName doesn't include path
  const baseName = imageName.replace(/^\/images\//, '').replace(/^[^/]+\//, '');
  
  // Map quality to folder name (same structure as videos and models)
  const qualityFolder = quality === 'original' ? 'original' : quality;
  
  // Return the full path with quality folder
  return `/images/${qualityFolder}/${baseName}`;
};

/**
 * Get image path from a full path, replacing with quality folder if needed
 * 
 * @param {string} fullPath - Full path like '/images/newspaper.jpg' or '/images/medium_quality/newspaper.png'
 * @param {string} quality - Quality level: 'low_quality', 'medium_quality', or 'original'
 * @returns {string} Updated path with quality folder
 */
export const updateImagePath = (fullPath, quality = 'medium_quality') => {
  // Extract image name from path (handles both /images/image.png and /images/quality/image.png)
  const match = fullPath.match(/\/images\/(?:[^/]+\/)?([^/]+\.(png|jpg|jpeg|webp|svg))$/);
  if (!match) {
    // If path doesn't match expected format, return as-is
    return fullPath;
  }
  
  const imageName = match[1];
  return getImagePath(imageName, quality);
};
